import React from 'react';
import { Route } from 'react-router';

export const getRequestInviteRoutes = () => {
  return (
    <Route name="branch">
      <Route
        path="/dealer/request-invite"
        getComponent={(loc, cb) =>
          import('./RequestInvite/ConnectedRequestInvite').then(c =>
            cb(null, c.ConnectedRequestInvite),
          )
        }
      />
    </Route>
  );
};
